module.exports = __webpack_public_path__ + "img/HC1009-177.d9238e1b.jpg";